<template >
  <div class="logManage-page section-main__warp">
    <ioc-table
      ref="crud"
      :data="tableData"
      :option="option"
      :page="page"
      @search-change="handleSearchChange"
      @search-reset="handleSearchReset"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <template slot="search_operateModule">
        <el-select
          placeholder="请选择"
          @change="selectOperateModules(queryForm.operateModule)"
          v-model="queryForm.operateModule"
        >
          <el-option
            v-for="item in options.operateModules"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="search_operateFunction">
        <el-select
          placeholder="请选择"
          v-model="queryForm.operateFunction"
          @change="selectOperateFunctions(queryForm.operateFunction)"
        >
          <el-option
            v-for="item in options.operateFunctions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="search_operateType">
        <el-select placeholder="请选择" v-model="queryForm.operateType">
          <el-option
            v-for="item in options.operateTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-download"
          @click="exportLogs"
        >
          导出
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-tooltip
          class="item"
          effect="dark"
          content="详情"
          placement="top-start"
        >
          <el-button
            type="text"
            icon="iconfont icon-Detail"
            @click="showDetails(scope.row)"
          ></el-button>
        </el-tooltip>
      </template>
    </ioc-table>
  </div>
</template>

<script>
import { Dic } from "$utils";
import utils from "@src/common/utils";
import { api, downLoad } from "../api/api";
import tableOption from "../options/logTable";
import { formatTimeToStr } from "../filter/dateUtils";
export default {
  name: "OperatorLog",
  data() {
    return {
      option: tableOption(this),
      page: {
        pageNo: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      options: {
        operateModules: [],
        operateFunctions: [],
        operateTypes: [],
      },
      tableData: [],
      queryForm: {
        operateModule: "",
        operateFunction: "",
        operateType: "",
      },
    };
  },
  mounted() {
    const self = this;
    this.options.operateModules = Dic.find("SENU059");
    console.log(Dic.find("SENU059"));
    this.getList();
  },
  methods: {
    getList() {
      const params = Object.assign(
        {
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize,
        },
        { ...this.queryForm }
      );

      if (
        params.operateModule !== undefined &&
        params.operateModule !== null &&
        params.operateModule !== ""
      ) {
        params.operateModule = "SENU059" + "." + this.queryForm.operateModule;
      }
      if (
        params.operateFunction !== undefined &&
        params.operateFunction !== null &&
        params.operateFunction !== ""
      ) {
        params.operateFunction =
          "SENU059" +
          Dic.Prefix(this.queryForm.operateModule) +
          "." +
          this.queryForm.operateFunction;
      }
      if (
        params.operateType !== undefined &&
        params.operateType !== null &&
        params.operateType !== ""
      ) {
        params.operateType =
          "SENU059" +
          Dic.Prefix(this.queryForm.operateModule) +
          Dic.Prefix(this.queryForm.operateFunction) +
          "." +
          this.queryForm.operateType;
      }
      if (params.operateTime) {
        params.startTime = formatTimeToStr(params.operateTime[0]);
        params.endTime = formatTimeToStr(params.operateTime[1]);
      }
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(api.queryLog, params).then((response) => {
        setTimeout(() => {
          loading.close();
        }, 500);
        this.tableData = response.returnObj.list;
        this.page.total = response.returnObj.total;
      });
    },
    indexMethod(index) {
      return this.pageSize * (this.currentPage - 1) + index + 1;
    },
    selectOperateModules(value) {
      this.queryForm.operateFunction = "";
      this.queryForm.operateType = "";
      this.options.operateFunctions = Dic.find("SENU059", { relation: value });
    },
    selectOperateFunctions(value) {
      this.queryForm.operateType = "";
      // 拼写补零
      const sourceKey = "SENU059" + Dic.Prefix(this.queryForm.operateModule);
      this.options.operateTypes = Dic.find(sourceKey, { relation: value });
      console.log(this.options.operateTypes);
    },
    exportLogs() {
      const self = this;
      const item = self.queryForm;
      let startTime = "";
      let endTime = "";
      if (item.operateTime) {
        startTime = formatTimeToStr(item.operateTime[0]);
        endTime = formatTimeToStr(item.operateTime[1]);
      }
      const param = {};
      if (
        item.operateModule !== undefined &&
        item.operateModule !== null &&
        item.operateModule !== ""
      ) {
        param.operateModule = "SENU059" + "." + item.operateModule;
      }
      if (
        item.operateFunction !== undefined &&
        item.operateFunction !== null &&
        item.operateFunction !== ""
      ) {
        param.operateFunction =
          "SENU059" +
          Dic.Prefix(item.operateModule) +
          "." +
          item.operateFunction;
      }
      if (
        item.operateType !== undefined &&
        item.operateType !== null &&
        item.operateType !== ""
      ) {
        param.operateType =
          "SENU059" +
          Dic.Prefix(item.operateModule) +
          Dic.Prefix(item.operateFunction) +
          "." +
          item.operateType;
      }
      param.operate = item.operate;
      param.operatorName = item.operatorName;
      param.startTime = startTime;
      param.endTime = endTime;
      param.self = self;
      downLoad(param);
    },
    showDetails(row) {
      this.$refs.crud.rowView(row);
    },
    handleSearchReset() {
      this.queryForm = {};
      this.page.pageSize = 10;
      this.getList();
    },
    handleSearchChange(param) {
      this.page.pageNo = 1;
      this.queryForm = Object.assign(this.queryForm, param);
      this.getList();
    },
    handleSizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.getList();
    },
    handleCurrentChange(pageNo) {
      this.page.pageNo = pageNo;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.logManage-page {
}
</style>